export default "__VITE_ASSET__e2c19d2e__"